export default function Footer() {
  const coreServices = [
    { label: "Man & Van Rubbish Removal Service", href: "#" },

    { label: "Bin Collection", href: "#" },
    { label: "Sofa Removal", href: "#" },
    { label: "Furniture Removal", href: "#" },
    { label: "Appliance Removal", href: "#" },
    { label: "House Clearance", href: "#" },
  ];

  const locations = [
    { label: "Rubbish Removal Birmingham", href: "/locations/birmingham-rubbish-removal" },
    { label: "Rubbish Removal Solihull", href: "/locations/solihull-rubbish-removal" },
    { label: "Rubbish Removal Droitwich Spa", href: "/locations/droitwich-spa-rubbish-removal" },
    { label: "Rubbish Removal Bromsgrove", href: "/locations/bromsgrove-rubbish-removal" },
    { label: "Rubbish Removal Redditch", href: "/locations/redditch-rubbish-removal" },
  ];

  const company = [
    { label: "About Cleario", href: "/about" },
    { label: "Careers", href: "#" },
    { label: "News", href: "/news" },
    { label: "Reviews", href: "#" },
    { label: "Contact Us", href: "/contact" },
  ];

  const socials = [
    { href: "#", label: "Facebook", icon: "ri-facebook-fill" },
    { href: "#", label: "Instagram", icon: "ri-instagram-line" },
    { href: "#", label: "LinkedIn", icon: "ri-linkedin-fill" },
    { href: "#", label: "X", icon: "ri-twitter-x-fill" },
  ];

  return (
    <footer className="bg-cl-dark">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 pt-6 pb-10">
        <div className="flex flex-col lg:flex-row gap-10 mb-14">
          {/* Brand col */}
          <div className="lg:w-2/5 flex-shrink-0">
            <a href="/" className="flex items-center gap-1 mb-6 cursor-pointer">
              <span className="text-2xl font-black tracking-tight text-white">
                Clear<span className="text-cl-lime">io</span>
              </span>
              <span className="w-2.5 h-2.5 rounded-full bg-cl-lime mb-4 inline-block border-2 border-white"></span>
            </a>
            <p className="text-white/60 text-sm leading-relaxed mb-5 max-w-xs font-semibold">
              The West Midlands&apos; most eco-responsible rubbish removal service. Same-day collection · &gt;95% recycled.
            </p>

            {/* Contact details */}
            <div className="flex flex-col gap-2.5 mb-7">
              <a
                href="tel:03335775445"
                className="flex items-center gap-2.5 text-white/60 hover:text-cl-lime text-sm font-semibold transition-colors cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-cl-lime/20 border border-cl-lime/30 flex-shrink-0">
                  <i className="ri-phone-fill text-cl-lime text-xs"></i>
                </span>
                03335 775445
              </a>
              <a
                href="https://cleario.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-white/60 hover:text-cl-lime text-sm font-semibold transition-colors cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-cl-lime/20 border border-cl-lime/30 flex-shrink-0">
                  <i className="ri-global-line text-cl-lime text-xs"></i>
                </span>
                www.cleario.uk
              </a>
              <div className="flex items-start gap-2.5 text-white/60 text-sm font-semibold">
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-cl-lime/20 border border-cl-lime/30 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-cl-lime text-xs"></i>
                </span>
                <span className="leading-relaxed">Unit 4, Crown Farm, Crown Lane,<br />Wychbold, Droitwich,<br />Worcestershire, WR9 0BX</span>
              </div>
            </div>

            {/* Social icons */}
            <div className="flex gap-3 mb-7">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/10 border-2 border-white/20 hover:bg-cl-lime hover:border-cl-lime hover:text-cl-dark text-white transition-all cursor-pointer cartoon-shadow-sm"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>

            {/* Trustpilot */}
            <div className="inline-flex items-center gap-3 bg-white/10 border-2 border-white/20 rounded-2xl px-4 py-3 cartoon-shadow-sm">
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#00b67a] text-sm"></i>
                ))}
              </div>
              <span className="text-white font-black text-sm">4.8</span>
              <span className="text-white/40 text-xs">·</span>
              <span className="text-white/60 text-xs font-semibold">200+ reviews</span>
            </div>
          </div>

          {/* Right side: links + newsletter below */}
          <div className="flex-1 flex flex-col gap-10">
            {/* Links row */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
              <div>
                <h3 className="text-cl-lime font-black text-xs uppercase tracking-widest mb-5">Services</h3>
                <ul className="flex flex-col gap-2.5">
                  {coreServices.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-white/60 hover:text-cl-lime text-sm font-semibold transition-colors cursor-pointer">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-cl-lime font-black text-xs uppercase tracking-widest mb-5">Locations</h3>
                <ul className="flex flex-col gap-2.5">
                  {locations.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-white/60 hover:text-cl-lime text-sm font-semibold transition-colors cursor-pointer">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-cl-lime font-black text-xs uppercase tracking-widest mb-5">Company</h3>
                <ul className="flex flex-col gap-2.5">
                  {company.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-white/60 hover:text-cl-lime text-sm font-semibold transition-colors cursor-pointer">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Newsletter strip — same width as the 3 columns above */}
            <div className="bg-white/5 border-2 border-white/10 rounded-3xl p-7 flex flex-col sm:flex-row items-center justify-between gap-6 cartoon-shadow-sm">
              <div>
                <p className="text-white font-black text-lg mb-1">Get tips &amp; offers in your inbox</p>
                <p className="text-white/60 text-sm font-semibold">Waste guides, seasonal offers, and Cleario news.</p>
              </div>
              <div className="flex gap-3 w-full sm:w-auto">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="flex-1 sm:w-56 bg-white/10 border-2 border-white/20 rounded-2xl px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-cl-lime"
                />
                <button className="bg-cl-lime text-cl-dark font-black px-6 py-3 rounded-2xl text-sm cartoon-btn whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Trust & payment badges row */}
        <div className="flex flex-wrap items-center justify-center gap-3 py-6 border-t-2 border-white/10 mb-2">
          {/* Visa */}
          <div className="flex items-center justify-center bg-white rounded-xl px-4 py-2.5 h-11 w-20">
            <svg viewBox="0 0 48 16" className="w-full h-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
              <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="14" fill="#1A1F71">VISA</text>
            </svg>
          </div>
          {/* Mastercard */}
          <div className="flex items-center justify-center bg-white rounded-xl px-3 py-2 h-11 w-20 gap-1">
            <div className="w-7 h-7 rounded-full bg-red-500 opacity-90"></div>
            <div className="w-7 h-7 rounded-full bg-yellow-400 opacity-90 -ml-3"></div>
          </div>
          {/* Safe Contractor */}
          <div className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 h-11">
            <i className="ri-shield-check-fill text-green-400 text-lg"></i>
            <span className="text-white text-xs font-black whitespace-nowrap">Safe Contractor</span>
          </div>
          {/* Environment Agency */}
          <div className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 h-11">
            <i className="ri-leaf-fill text-green-400 text-lg"></i>
            <span className="text-white text-xs font-black whitespace-nowrap">Env. Agency Licensed</span>
          </div>
          {/* Waste Carrier */}
          <div className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 h-11">
            <i className="ri-government-fill text-blue-400 text-lg"></i>
            <span className="text-white text-xs font-black whitespace-nowrap">CBDU 634440</span>
          </div>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-white/10">
          <div className="text-white/40 text-xs leading-relaxed text-center md:text-left font-semibold">
            <p>&copy; Cleario 2026. All rights reserved. Cleario is a trading name of Cleario Limited.</p>
            <p className="mt-0.5">
              <span className="text-white/60">Waste Carrier Licence:</span> CBDU 634440 &nbsp;·&nbsp;
              <span className="text-white/60">Company Reg:</span> 17106891
            </p>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 hover:text-white/70 text-xs cursor-pointer whitespace-nowrap font-semibold">Terms</a>
            <span className="text-white/20">|</span>
            <a href="#" className="text-white/40 hover:text-white/70 text-xs cursor-pointer whitespace-nowrap font-semibold">Privacy Policy</a>
            <span className="text-white/20">|</span>
            <a href="#" className="text-white/40 hover:text-white/70 text-xs cursor-pointer whitespace-nowrap font-semibold">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
